import type { WireSourceHealthRow } from '@logistics/contracts';

type Status = WireSourceHealthRow['status'];

/** A source status as the design shows it: a coloured dot and a word. */
export function statusLook(status: Status): { color: string; label: string } {
  switch (status) {
    case 'ok':
      return { color: 'var(--ok)', label: 'Connected' };
    case 'error':
      return { color: 'var(--bad)', label: 'Error' };
    case 'disabled':
      return { color: 'var(--mute)', label: 'Disabled' };
    case 'pending':
      return { color: 'var(--mute)', label: 'Pending' };
  }
}

/** The latency bar's width: full at 1.5 s, as in the design. */
export function latencyWidth(ms: number | undefined): string {
  return `${Math.min(100, (ms ?? 0) / 15)}%`;
}
